// Settings-panel SSO targets. Each entry is a `/sso/vendors/:tenant` deeplink
// that `SsoVendorPage` resolves at runtime against the legacy REST host.
const SSO_BASE = "/sso/vendors/emblem";

// `FIND_CARE` has no entry in `VENDOR_SSO_LINKS` — that deeplink is authored in
// Masonry config, and `FindCareRouteGuard` matches on the id to pick between
// the SSO link-out and the in-app Care Finder capability.
export const SSO_VENDOR_IDS = {
  FIND_CARE: "find-care",
  MY_PROFILE: "my-profile",
} as const;

export const VENDOR_SSO_LINKS = {
  MY_PROFILE: `${SSO_BASE}?vendorId=${SSO_VENDOR_IDS.MY_PROFILE}`,
} as const;
